import React, { useEffect, useState } from "react";

import RealEstateOpportunities from "../../Components/RealEstateOppurtunities";
import emptyState from "../../Assets/Images/emptyState.png";
import Navbar from "../../Components/Navbar";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loader from "../../Components/Utils/Loader";
import { useDispatch, useSelector } from "react-redux";
import { getREInvestments } from "../../store/actions/realEstate/getREInvestments";
import { LiaAngleLeftSolid } from "react-icons/lia";
import FilterButton from "../../Components/Buttons/FilterButton";

const RealEstateInvestment = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  const dispatch = useDispatch();

  const [params] = useSearchParams();
  const currency = params.get("currency");
  // const [investments, setInvestments] = useState([]);

  const {
    opportunities: opportunitiesData,
    REInvestments,
    pending,
  } = useSelector((state) => state.opportunities);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(
      getREInvestments({
        currency,
        cb: (response) => {
          setLoading(false);
        },
      })
    );
  }, [currency]);

  useEffect(() => {
    if (currency !== "NGR" && currency !== "USD") {
      navigate(-1);
    }
  }, []);

  const [activeTab, setActiveTab] = useState("1");
  const navigate = useNavigate();

  return (
    <>
      <div className="flex flex-col bg-[#F9FAFA] gap-6 pt-3 pb-3 items-center min-h-screen">
        <Navbar type={3} />

        <div className="w-[95%] min-h-[80vh]  h-full flex flex-col rounded-[12px] gap-10 p-10 bg-[#FFF] border-[#F2F2F2] border-[1.1px] drop-shadow-custom max-w-[1664px]">
          <div
            onClick={() => navigate(-1)}
            className="flex cursor-pointer items-center mb-4"
          >
            <LiaAngleLeftSolid
              size={18}
              color="#131E3D"
              className="mx-[2px]  "
            />
            <h3 className="text-[14px] font-[400] text-[#131E3D]">Back</h3>
          </div>
          <div className="flex flex-col justify-center items-center mb-2">
            <div className=" mb-[50px]  max-w-[652px]">
              <h2 className=" font-[400]  text-[#131e3d] text-center   md:text-[54px] text-[48px] leading-[49.4px] md:leading-[59.4px]  tracking-[-3.1%] ">
                Invest in well-vetted real estate assets
              </h2>
            </div>

            <div className="max-w-[366px] shadow-md p-2 h-[49px] border-[1px] rounded-[41px] flex justify-center items-center">
              <div className="text-[10px] sm:text-[14px] font-[500] flex justify-center items-center lg:gap-2">
                <button
                  className={`py-1 font-[400] w-[72px] h-[37px] px-1 rounded-[40px] ${
                    activeTab === "1" ? "bg-[#F1EDFB] text-[#6935D3]" : ""
                  }`}
                  onClick={() => setActiveTab("1")}
                >
                  Active
                </button>
                <button
                  className={`w-[76px] font-[400] h-[37px] py-1 px-1 rounded-[40px] ${
                    activeTab === "0" ? "bg-[#F1EDFB] text-[#6935D3]" : ""
                  }`}
                  onClick={() => setActiveTab("0")}
                >
                  Closed
                </button>
                <button
                  className={`w-[60px] font-[400] h-[37px] py-1 px-1 rounded-[40px] ${
                    activeTab === "8" ? "bg-[#F1EDFB] text-[#6935D3]" : ""
                  }`}
                  onClick={() => setActiveTab("8")}
                >
                  Sold
                </button>
                <button
                  className={`w-[118px] font-[400] h-[37px] py-1 px-1 rounded-[40px] ${
                    activeTab === "9" ? "bg-[#F1EDFB] text-[#6935D3]" : ""
                  }`}
                  onClick={() => setActiveTab("9")}
                >
                  Coming Soon
                </button>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-6">
            {loading ? (
              <div className="my-8">
                <Loader />
              </div>
            ) : REInvestments?.filter((item) => item?.status == activeTab)
                ?.length < 1 ? (
              <div className="w-full flex-col h-[300px] flex justify-center items-center">
                <img
                  src={emptyState}
                  alt=""
                  className=" mb-[5px] w-[76px] h-[76px] "
                />
                <div className=" mb-[5px] p-2 text-[16px] font-[400] text-[#9C9C9E] ">
                  No Investments.
                </div>
              </div>
            ) : (
              REInvestments?.filter((item) => item?.status == activeTab)?.map(
                (item, index) => {
                  return (
                    <RealEstateOpportunities
                      key={item?.id}
                      onClick={() => {
                        navigate(`/investment/RealEstate/${item?.id}`, {
                          state: item,
                        });
                      }}
                      total_units={item?.total_units}
                      currency={item?.currency}
                      imageSrc={item?.properties_images[0]}
                      location={item?.location}
                      title={item?.name}
                      status={item?.status}
                      price={item?.amount_per_unit}
                      investedPercentage={(
                        (item?.total_amount_invested /
                          (item?.total_units * item?.amount_per_unit)) *
                        100
                      ).toFixed(1)}
                      totalAmount={item?.total_units * item?.amount_per_unit}
                    />
                  );
                }
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default RealEstateInvestment;
